module.exports = __webpack_public_path__ + "img/guaranteeSate_08.6719157e.png";